(function(){
  'use strict';
  const garmentNames={
    'T-Shirt':['Gildan G5000','Bella+Canvas 3001','Comfort Colors 1717','ATC 2000','Shaka Wear MHVWT','Bella+Canvas 3010','Shaka Wear MHVWT GD','ATC WERK250'],
    'Hoodie':['ATCF2500','Canada Sportswear L00550','Just Like Hero HERO-2020','Canada Sportswear L00580','Champion Reverse Weave','ATC WeRK420','Independent IND4000'],
    'Sweatshirt':['ATCF2400','Canada Sportswear L00540','ATCF6400','Shaka Wear Max Heavyweight','Comfort Colors 1566'],
    'Tank Top':['Gildan 5200','ATC1004','ATC1002','Comfort Colors 9360','Shaka Wear Tank Top','Shaka Wear Muscle Tee']
  };

  const garmentDisplayNames={
    'Shaka Wear MHVWT':'Shaka Max Heavyweight',
    'Shaka Wear MHVWT GD':'Shaka MHVWT Garment Dye',
    'Canada Sportswear L00550':'CSW L00550',
    'Just Like Hero HERO-2020':'JLH HERO-2020',
    'Canada Sportswear L00580':'CSW L00580',
    'ATC WeRK420':'ATC WERK420',
    'Canada Sportswear L00540':'CSW L00540',
    'Shaka Wear Max Heavyweight':'Shaka Heavyweight Long Sleeve'
  };

  const supplierTax={
    'S&S Canada':0.05,
    'Fabrik':0.12,
    'SanMar Canada':0.05,
    'Toba Sportswear':0.12,
    'Canada Sportswear':0.05
  };

  const qPoints=[1,2,3,5,10,15,25,50,60,75,100];

  // [garment,supplier,S-XL price,free freight threshold,shipping@1..100]
  const purchasing=[
    ['Gildan G5000','S&S Canada',3.76,300,[9.27,9.27,10.22,10.22,12.68,14.26,15.95,20.06,22.2,35.55,0]],
    ['Bella+Canvas 3001','Toba Sportswear',7.27,0,[0,0,0,0,0,0,0,0,0,0,0]],
    ['Comfort Colors 1717','S&S Canada',8.54,300,[9.27,9.27,10.22,11.01,12.68,14.71,16.45,0,0,0,0]],
    ['ATC 2000','Fabrik',4.71,399,[11.61,12.24,12.86,14.1,17.11,20.1,26.17,41.09,47.1,56.13,0]],
    ['ATC 2000','SanMar Canada',4.62,300,null],
    ['Shaka Wear MHVWT','Fabrik',14.36,399,[12.86,14.72,16.59,20.32,29.27,37.43,55.06,0,0,0,0]],
    ['Bella+Canvas 3010','Toba Sportswear',10.49,0,[0,0,0,0,0,0,0,0,0,0,0]],
    ['Shaka Wear MHVWT GD','Fabrik',20.74,399,[13.69,16.38,19.08,24.47,37.39,49.19,0,0,0,0,0]],
    ['ATC WERK250','Fabrik',10.49,399,[12.35,13.72,15.08,17.81,24.33,30.7,43.85,0,0,0,0]],
    ['ATC WERK250','SanMar Canada',11.49,300,null],
    ['ATCF2500','Fabrik',14.34,399,[12.85,14.72,16.58,20.31,29.32,38.25,56.43,0,0,0,0]],
    ['ATCF2500','SanMar Canada',11.95,300,null],
    ['Canada Sportswear L00550','Canada Sportswear',14.46,300,[48.69,48.69,48.69,48.69,48.69,49.59,0,0,0,0,0]],
    ['Just Like Hero HERO-2020','Fabrik',21.7,399,[13.81,16.63,19.45,25.1,38.54,51.65,0,0,0,0,0]],
    ['Canada Sportswear L00580','Canada Sportswear',28.15,300,[48.69,48.69,48.69,48.69,48.69,0,0,0,0,0,0]],
    ['Champion Reverse Weave','Fabrik',66.95,399,[19.69,28.4,37.1,54.51,0,0,0,0,0,0,0]],
    ['Gildan 5200','S&S Canada',4.99,300,[20.62,20.62,21.17,21.17,22.29,23.49,25.87,32.27,35.15,0,0]],
    ['ATC1004','Fabrik',7.82,399,[12.01,13.02,14.04,16.07,20.99,25.87,35.79,60.13,0,0,0]],
    ['ATC1004','SanMar Canada',8.01,300,null],
    ['ATC1002','Fabrik',3.95,399,[11.5,12.02,12.53,13.56,16.03,18.5,23.5,35.82,40.79,48.24,60.65]],
    ['ATC1002','SanMar Canada',8.41,300,null],
    ['Comfort Colors 9360','S&S Canada',9.14,300,[20.62,20.62,21.17,21.85,22.82,24.04,26.47,0,0,0,0]],
    ['Shaka Wear Tank Top','Fabrik',10.37,399,[12.34,13.69,15.03,17.73,24.19,30.1,42.84,0,0,0,0]],
    ['Shaka Wear Muscle Tee','Fabrik',19.94,399,[13.58,16.17,18.77,23.95,36.38,47.73,0,0,0,0,0]],
    ['ATCF2400','Fabrik',11.99,399,[12.55,14.11,15.67,18.78,26.32,33.79,48.98,0,0,0,0]],
    ['ATCF2400','SanMar Canada',12.01,300,null],
    ['Canada Sportswear L00540','Canada Sportswear',14.6,300,[48.69,48.69,48.69,48.69,48.69,49.59,0,0,0,0,0]],
    ['ATCF6400','Fabrik',17.99,399,[13.33,15.67,18.01,22.68,33.99,45.19,0,0,0,0,0]],
    ['ATCF6400','SanMar Canada',18.99,300,null],
    ['Shaka Wear Max Heavyweight','Fabrik',19.14,399,[13.48,15.97,18.45,23.43,35.35,46.25,0,0,0,0,0]],
    ['Comfort Colors 1566','S&S Canada',28.07,300,[21.17,21.85,22.82,24.04,28.57,0,0,0,0,0,0]],
    ['ATC WeRK420','Fabrik',30.13,399,[14.99,19,23,31,50.16,0,0,0,0,0,0]],
    ['ATC WeRK420','SanMar Canada',25.99,300,null],
    ['Independent IND4000','Fabrik',34.72,399,[15.54,20.09,24.64,33.74,56.13,0,0,0,0,0,0]]
  ];

  const screenQty=[1,2,3,5,10,12,15,20,25,50,75,100,250,500];
  const screenRates={
    1:[58.25,34.5,25.75,17.5,9,8.5,7.75,7,6.25,4.25,3.25,2,1.25,.75],
    2:[88.25,50,36.5,24.5,13,12.25,11.25,10,9,5.5,4.5,3.25,2.25,1.25],
    3:[118.25,65.5,47.25,31.5,17,16,14.75,13,11.75,6.75,5.75,4.5,3.25,1.75],
    4:[148.25,81,58,38.5,21,19.75,18.25,16,14.5,8,7,5.75,4.25,2.25],
    5:[178.25,96.5,68.75,45.5,25,23.5,21.75,19,17.25,9.25,8.25,7,5.25,2.75],
    6:[208.25,112,79.5,52.5,29,27.25,25.25,22,20,10.5,9.5,8,6.25,3.25]
  };

  const dtfQty=[1,2,3,5,10,15,25,50,100,250,500,1000];
  const dtfSmallCharge=[52.75,32.75,26.5,19,12,9.5,8,6.5,4.5,3.5,3,2.5];
  const dtfLargeCharge=[52.75,36.25,30.75,25.5,19,16.75,15.5,14,12,11,10.5,9.75];
  const gangCosts=[13.43,20.15,25.75,32.47,38.07,44.79,51.51,57.11,62.71,69.43,75.03,81.75,87.35,95.19,99.67,106.39,111.99,118.71,124.31,139.99,154.55,170.23,185.91];
  const smallCaps=[16,24,32,44,52,60,68,76,88,96,104,112,124,132,140,148,156,168,176,196,220,244,264];
  const largeCaps=[1,2,3,3,4,5,6,7,7,8,9,10,11,11,12,13,14,15,15,17,19,21,23];

  const money=v=>'$'+Number(v).toFixed(2);
  const ceilQuarter=v=>Math.ceil((Number(v)-1e-10)*4)/4;
  const roundQuarter=v=>Math.round((Number(v)+1e-10)*4)/4;

  function interpAnchors(qty,qs,vals){
    if(qty<=qs[0])return vals[0];
    if(qty>=qs[qs.length-1])return vals[vals.length-1];
    for(let i=0;i<qs.length-1;i++){
      if(qty>=qs[i]&&qty<=qs[i+1]){
        const t=(qty-qs[i])/(qs[i+1]-qs[i]);
        return vals[i]+((vals[i+1]-vals[i])*t);
      }
    }
    return vals[vals.length-1];
  }

  function interpolateShipping(qty,values){
    if(!Array.isArray(values))return null;
    const points=[];
    for(let i=0;i<qPoints.length;i++){
      const v=values[i];
      if(typeof v==='number'&&Number.isFinite(v))points.push([qPoints[i],v]);
    }
    if(!points.length)return null;
    if(qty<=points[0][0])return points[0][1];
    if(qty>=points[points.length-1][0])return points[points.length-1][1];
    for(let i=0;i<points.length-1;i++){
      const a=points[i],b=points[i+1];
      if(qty>=a[0]&&qty<=b[0]){
        if(a[0]===b[0])return a[1];
        return a[1]+((qty-a[0])*(b[1]-a[1])/(b[0]-a[0]));
      }
    }
    return points[points.length-1][1];
  }

  function landedPerShirt(garment,qty){
    const rows=purchasing.filter(row=>row[0]===garment);
    const costs=[];
    for(const row of rows){
      const supplier=row[1],basePrice=row[2],threshold=row[3],ship=row[4];
      if(!(typeof basePrice==='number'&&Number.isFinite(basePrice)))continue;
      const pretax=qty*basePrice;
      const tax=supplierTax[supplier]??0.12;
      let jobCost;
      if(threshold===0||pretax>=threshold){
        jobCost=pretax*(1+tax);
      }else{
        const shipping=interpolateShipping(qty,ship);
        if(shipping===null)continue;
        jobCost=(pretax+shipping)*(1+tax);
      }
      if(Number.isFinite(jobCost))costs.push(jobCost);
    }
    if(!costs.length)return null;
    return Math.min(...costs)/qty;
  }

  function locationCounts(location){
    // Chest printing uses the same small transfer model on either side.
    if(location==='left-chest'||location==='right-chest')return{nloc:1,nlarge:0,hasSmall:true};
    if(location==='full-front'||location==='full-back')return{nloc:1,nlarge:1,hasSmall:false};
    // Small chest logo plus a large back print: do not charge for two full-size prints.
    if(location==='left-chest-back'||location==='right-chest-back')return{nloc:2,nlarge:1,hasSmall:true};
    // Legacy front-back denotes full front plus full back; keep old estimates compatible.
    if(location==='front-back')return{nloc:2,nlarge:2,hasSmall:false};
    return{nloc:1,nlarge:1,hasSmall:false};
  }

  function screenPerShirt(qty,colours,location){
    const c=Number(colours);
    if(!screenRates[c])return null;
    const q=Math.min(qty,500);
    const oneLocation=interpAnchors(q,screenQty,screenRates[c]);
    return roundQuarter(oneLocation*locationCounts(location).nloc);
  }

  function minGangCost(printCount,caps){
    if(printCount<=0)return 0;
    let best=Infinity;
    for(let i=0;i<caps.length;i++){
      const cap=caps[i],cost=gangCosts[i];
      if(!cap||!Number.isFinite(cost))continue;
      best=Math.min(best,Math.ceil(printCount/cap)*cost);
    }
    return Number.isFinite(best)?best:0;
  }

  function dtfPerShirt(qty,location){
    if(qty<1||qty>1000)return null;
    const {nloc,nlarge,hasSmall}=locationCounts(location);
    const primary=interpAnchors(qty,dtfQty,nlarge>0?dtfLargeCharge:dtfSmallCharge);
    const smallCost=hasSmall?minGangCost(qty,smallCaps):0;
    const largeOne=nlarge>0?minGangCost(qty,largeCaps):0;
    const largeAll=nlarge>0?minGangCost(qty*nlarge,largeCaps):0;
    const incremental=(nlarge>0?((largeAll-largeOne)/qty):0)+(hasSmall&&nlarge>0?(smallCost/qty):0);
    const rawApp=5.5-(4.75*Math.log10(qty)/Math.log10(1000));
    const app=Math.max(1,ceilQuarter(rawApp));
    return roundQuarter(primary+incremental+(app*(nloc-1)));
  }

  function quotePrint(qty,colours,location){
    const isFull=colours==='full';
    const isUnsure=colours==='unsure';
    if(qty>1000&&(isFull||isUnsure))return{perShirt:null,method:'EXACT QUOTE'};
    const dtf=dtfPerShirt(qty,location);
    if(isFull||isUnsure||qty<10)return{perShirt:dtf,method:'DTF'};
    const screen=screenPerShirt(qty,colours,location);
    if(dtf===null)return{perShirt:screen,method:'SCREEN PRINT'};
    return screen<=dtf
      ?{perShirt:screen,method:'SCREEN PRINT'}
      :{perShirt:dtf,method:'DTF'};
  }

  function quotePrintMode(qty,colours,location,mode){
    if(mode==='screen'){
      // Public estimator policy: below 10 garments, DTF only (all garment types).
      // Screen print can be overridden only for 10+ with eligible print colours.
      if(qty<10||colours==='full'||colours==='unsure')return{perShirt:null,method:'SCREEN PRINT',unavailable:true};
      const value=screenPerShirt(qty,colours,location);
      return Number.isFinite(value)?{perShirt:value,method:'SCREEN PRINT'}:{perShirt:null,method:'SCREEN PRINT',unavailable:true};
    }
    if(mode==='dtf'){
      const value=dtfPerShirt(qty,location);
      return Number.isFinite(value)?{perShirt:value,method:'DTF'}:{perShirt:null,method:'DTF',unavailable:true};
    }
    return quotePrint(qty,colours,location);
  }



  function calculateEstimate(input){
    input=input||{};
    const qty=Math.min(10000,Math.max(1,Math.round(Number(input.quantity)||1)));
    const type=input.garmentType||'';
    const location=input.printLocation||'';
    const colours=input.colours||'';
    const requestedMode=(input.printMode==='screen'||input.printMode==='dtf')?input.printMode:'auto';
    const recommended=quotePrint(qty,colours,location);
    const chosen=quotePrintMode(qty,colours,location,requestedMode);

    if(chosen.unavailable||chosen.perShirt===null){
      return {
        ok:false,
        reason:requestedMode==='screen'?'Screen printing is not available for these estimate settings.':'This estimate needs a custom quote.',
        recommendedMethod:recommended&&recommended.method?recommended.method:''
      };
    }

    const options=(garmentNames[type]||[]).map(name=>{
      const landed=landedPerShirt(name,qty);
      if(landed===null)return null;
      const garmentCharge=ceilQuarter(landed);
      const perShirt=garmentCharge+chosen.perShirt;
      return{
        name,
        label:garmentDisplayNames[name]||name,
        perShirt,
        total:perShirt*qty,
        method:chosen.method
      };
    }).filter(Boolean).sort((a,b)=>a.total-b.total);

    if(!options.length){
      return {ok:false,reason:'No estimator garments are available for that garment type.',recommendedMethod:recommended&&recommended.method?recommended.method:''};
    }

    let picked=options.find(item=>item.name===input.selectedGarment)||options[0];
    return {
      ok:true,
      quantity:qty,
      garmentType:type,
      selectedGarment:picked.name,
      selectedGarmentLabel:picked.label,
      printLocation:location,
      colours,
      printMode:requestedMode,
      printMethod:picked.method,
      recommendedMethod:recommended&&recommended.method?recommended.method:'',
      methodSelection:requestedMode==='auto'?'Recommended':'Customer override',
      estimatedTotal:picked.total,
      estimatedEach:picked.perShirt,
      options
    };
  }

  window.MM_ESTIMATOR_ENGINE={
    garmentNames,
    garmentDisplayNames,
    calculate:calculateEstimate
  };
})();
